import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import "../css/StudentDetails.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaEdit,
  FaTrash,
  FaEye,
  FaDownload,
  FaPlus,
  FaFilePdf,
  FaImage,
  FaSignature,
  FaSearch,
  FaTimes,
  FaSync,
  FaFilter,
  FaTable,
  FaColumns
} from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const API_URL = "https://auxititpt.org/Backend/student_api.php";
const TRADE_API_URL = "https://auxititpt.org/Backend/trade_api.php";
const LETTERHEAD_IMAGE = "https://auxititpt.org/public/uploads/Letter_Head_Axilium_English.jpg";

const StudentDetails = () => {
  const [students, setStudents] = useState([]);
  const [tradeList, setTradeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [editStudent, setEditStudent] = useState(null);

  // Modal-based filters state (applied)
  const [filterTrades, setFilterTrades] = useState([]); // array of trade_name
  const [filterQualifications, setFilterQualifications] = useState([]); // array
  const [filterGenders, setFilterGenders] = useState([]); // array
  const [filterReligions, setFilterReligions] = useState([]); // array
  const [filterCommunities, setFilterCommunities] = useState([]); // array
  const [filterOrphan, setFilterOrphan] = useState([]); // array: "Yes"/"No"
  const [filterFirstGraduate, setFilterFirstGraduate] = useState([]); // array: "Yes"/"No"

  // Modal visibility and temporary selections
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tempTrades, setTempTrades] = useState([]);
  const [tempQualifications, setTempQualifications] = useState([]);
  const [tempGenders, setTempGenders] = useState([]);
  const [tempReligions, setTempReligions] = useState([]);
  const [tempCommunities, setTempCommunities] = useState([]);
  const [tempOrphan, setTempOrphan] = useState([]);
  const [tempFirstGraduate, setTempFirstGraduate] = useState([]);
  // ---- NEW: Batch (admission year) filter ----
  const [filterYears, setFilterYears] = useState([]);           // applied
  const [tempYears, setTempYears] = useState([]);               // modal temp
  // Search
  const [searchQuery, setSearchQuery] = useState("");

  // Table display preferences
  const [showAllColumns, setShowAllColumns] = useState(false);

  const initialFormData = {
    name: "",
    trade: "",
    date_of_birth: "",
    address: "",
    father_name: "",
    mother_name: "",
    gender: "",
    religion: "",
    community: "",
    sub_caste: "",
    annual_income: "",
    qualification: "",
    aadhar_no: "",
    mobile_no: "",
    orphan: "",
    first_graduation: "",
    date_of_admission: "",
    student_photo: null,
    student_signature: null,
    scanned_documents: null,
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    await Promise.all([fetchStudents(), fetchTrades()]);
    setLoading(false);
  };

  const fetchStudents = async () => {
    try {
      const res = await fetch(`${API_URL}?type=all`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setStudents(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch students error:", err);
      alert("Failed to load students. Check console.");
    }
  };

  const fetchTrades = async () => {
    try {
      const res = await fetch(TRADE_API_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const arr = Array.isArray(data) ? data : [];
      const sorted = [...arr].sort((a, b) => {
        const aTime = a.created_at ? new Date(a.created_at).getTime() : 0;
        const bTime = b.created_at ? new Date(b.created_at).getTime() : 0;
        return aTime - bTime;
      });
      setTradeList(sorted);
    } catch (err) {
      console.error("Fetch trades error:", err);
      setTradeList([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    if (name === "trade") {
      const t = tradeList.find((x) => x.trade_name === value);
      if (t && t.qualification) {
        setFormData((prev) => ({ ...prev, qualification: prev.qualification || t.qualification }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.trade || !formData.mobile_no) {
      alert("Name, Trade, and Mobile No are required");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("trade", formData.trade);
    formDataToSend.append("mobile_no", formData.mobile_no);
    formDataToSend.append("date_of_birth", formData.date_of_birth || "");
    formDataToSend.append("address", formData.address || "");
    formDataToSend.append("father_name", formData.father_name || "");
    formDataToSend.append("mother_name", formData.mother_name || "");
    formDataToSend.append("gender", formData.gender || "");
    formDataToSend.append("religion", formData.religion || "");
    formDataToSend.append("community", formData.community || "");
    formDataToSend.append("sub_caste", formData.sub_caste || "");
    formDataToSend.append("annual_income", formData.annual_income || "");
    formDataToSend.append("qualification", formData.qualification || "");
    formDataToSend.append("aadhar_no", formData.aadhar_no || "");
    formDataToSend.append("orphan", formData.orphan || "");
    formDataToSend.append("first_graduation", formData.first_graduation || "");
    formDataToSend.append("date_of_admission", formData.date_of_admission || "");
    if (formData.student_photo) formDataToSend.append("student_photo", formData.student_photo);
    if (formData.student_signature) formDataToSend.append("student_signature", formData.student_signature);
    if (formData.scanned_documents) formDataToSend.append("scanned_documents", formData.scanned_documents);

    try {
      const url = editStudent ? `${API_URL}?id=${editStudent.student_id}` : API_URL;
      const response = await fetch(url, { method: "POST", body: formDataToSend });
      const text = await response.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (err) {
        console.error("Invalid JSON from server:", text);
        throw new Error("Server returned invalid response");
      }
      if (response.ok && result.status === "success") {
        alert(editStudent ? "Student updated!" : "Student added!");
        await fetchStudents();
        resetForm();
      } else {
        throw new Error(result.message || "Operation failed");
      }
    } catch (err) {
      console.error("Submit error:", err);
      alert("Error: " + err.message);
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setEditStudent(null);
    setShowForm(false);
  };

  const openAddForm = async () => {
    await fetchTrades();
    setFormData(initialFormData);
    setEditStudent(null);
    setShowForm(true);
  };

  const handleView = async (student) => {
    try {
      const res = await fetch(`${API_URL}?id=${student.student_id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const fullStudent = await res.json();
      setSelectedStudent(fullStudent);
      setShowViewModal(true);
    } catch (err) {
      console.error("View error:", err);
      alert("Failed to load student details");
    }
  };

  const handleEdit = async (student) => {
    await fetchTrades();
    setFormData({
      name: student.name || "",
      trade: student.trade || "",
      date_of_birth: student.date_of_birth || "",
      address: student.address || "",
      father_name: student.father_name || "",
      mother_name: student.mother_name || "",
      gender: student.gender || "",
      religion: student.religion || "",
      community: student.community || "",
      sub_caste: student.sub_caste || "",
      annual_income: student.annual_income || "",
      qualification: student.qualification || "",
      aadhar_no: student.aadhar_no || "",
      mobile_no: student.mobile_no || "",
      orphan: student.orphan || "",
      first_graduation: student.first_graduation || "",
      date_of_admission: student.date_of_admission || "",
      student_photo: null,
      student_signature: null,
      scanned_documents: null,
    });
    setEditStudent(student);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this student permanently?")) return;
    try {
      const res = await fetch(`${API_URL}?id=${id}`, { method: "DELETE" });
      const result = await res.json();
      if (res.ok && result.status === "success") {
        alert("Student deleted!");
        await fetchStudents();
      } else {
        throw new Error(result.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Error: " + err.message);
    }
  };

  // ------------------------------
// EXPORT: EXCEL – ONLY FILTERED DATA
// ------------------------------
const exportToExcel = () => {
  // Use filteredStudents (already includes search + all filters)
  const dataToExport = filteredStudents;

  if (!dataToExport || dataToExport.length === 0) {
    alert("No student data to export (filtered results are empty)");
    return;
  }

  // Map the filtered data to include all fields with proper formatting
  const exportData = dataToExport.map(student => {
    return {
      'Admission Code': student.admission_code || "N/A",
      'Name': student.name || "",
      'Trade': student.trade || "",
      'Date of Birth': student.date_of_birth || "",
      'Address': student.address || "",
      "Father's Name": student.father_name || "",
      "Mother's Name": student.mother_name || "",
      'Gender': student.gender || "",
      'Religion': student.religion || "",
      'Community': student.community || "",
      'Sub Caste': student.sub_caste || "",
      'Annual Income (₹)': student.annual_income || "",
      'Qualification': student.qualification || "",
      'Aadhar No': student.aadhar_no || "",
      'Mobile No': student.mobile_no || "",
      'Orphan': student.orphan ? 'Yes' : 'No',
      'First Graduate': student.first_graduation ? 'Yes' : 'No',
      'Date of Admission': student.date_of_admission || "",
      'Photo URL': student.student_photo_url ? `https://localhost${student.student_photo_url}` : "",
      'Signature URL': student.student_signature_url ? `https://localhost${student.student_signature_url}` : "",
      'Documents URL': student.scanned_documents_url ? `https://localhost${student.scanned_documents_url}` : "",
    };
  });

  // Convert JSON → Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

  // Apply column width adjustments
  const wscols = [
    { wch: 15 }, // Admission Code
    { wch: 25 }, // Name
    { wch: 20 }, // Trade
    { wch: 15 }, // DOB
    { wch: 30 }, // Address
    { wch: 25 }, // Father's Name
    { wch: 25 }, // Mother's Name
    { wch: 10 }, // Gender
    { wch: 15 }, // Religion
    { wch: 15 }, // Community
    { wch: 15 }, // Sub Caste
    { wch: 15 }, // Annual Income
    { wch: 20 }, // Qualification
    { wch: 20 }, // Aadhar
    { wch: 15 }, // Mobile
    { wch: 10 }, // Orphan
    { wch: 15 }, // First Graduate
    { wch: 15 }, // Admission Date
    { wch: 30 }, // Photo URL
    { wch: 30 }, // Signature URL
    { wch: 30 }  // Documents URL
  ];

  worksheet['!cols'] = wscols;

  // Generate filename with filter info
  const filterInfo = activeFilterCount() > 0 || searchQuery ? "_Filtered" : "";
  const today = new Date().toISOString().split('T')[0];
  const filename = `Student_Details${filterInfo}_${today}.xlsx`;

  // Export workbook
  XLSX.writeFile(workbook, filename);
};

  const handlePrintForStudent = (student) => {
    const formattedDOB = student.date_of_birth
      ? new Date(student.date_of_birth).toLocaleDateString("en-GB")
      : "—";
    const formattedAdmission = student.date_of_admission
      ? new Date(student.date_of_admission).toLocaleDateString("en-GB")
      : "—";

    const popup = window.open("", "_blank", "width=900,height=1000,scrollbars=no,resizable=yes");

    popup.document.write(`
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Student Details - ${student.admission_code || "N/A"}</title>
  <style>
    @page { size: A4; margin: 0; }
    html, body { margin:0; padding:0; height:297mm; overflow:hidden; }
    body {
      font-family: 'Poppins', sans-serif;
      position: relative;
      font-size: 0.95rem;
      line-height: 1.4;
    }

    /* Letterhead Background */
    body::before {
      content: '';
      position: fixed;
      top: 0; left: 0;
      width: 210mm; height: 297mm;
      background: url('${LETTERHEAD_IMAGE}') no-repeat top center / 100% auto;
      z-index: -1;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    /* Content starts after letterhead */
    .content {
      padding: 60mm 8mm 8mm 8mm; /* Adjust 105mm based on your letterhead height */
      position: relative;
      z-index: 1;
    }

    .title {
      text-align: center;
      text-decoration: underline;
      font-size: 1.35rem;
      margin: 0 0 6px;
    }

    /* Header Table: Photo + Admission Code - NO BORDERS */
    .header-table {
      width: 100%;
      border-collapse: collapse;
      margin: 4px 0 10px 0;
    }
    .header-table td {
      border: none !important;
      padding: 2px 0;
      vertical-align: top;
    }
    .photo-cell { width: 55%; }
    .code-cell { width: 45%; text-align: right; }
    .admission-code {
      font-weight: bold;
      font-size: 1.15rem;
      margin: 0;
    }

    /* Main Details Table */
    .details-table {
      width: 100%;
      border-collapse: collapse;
      margin: 6px 0;
    }
    .details-table td {
      padding: 3px 4px;
      border: 1px solid #000 !important;
      font-size: 0.92rem;
    }

    .photo-section {
      margin: 3px 0;
    }
    .student-photo, .student-signature {
      max-width: 85px;
      max-height: 85px;
      border: 1px solid #ccc;
      display: inline-block;
    }

    .signature {
      margin-top: 25px;
      text-align: right;
      font-weight: bold;
      font-size: 1rem;
    }

    @media print {
      body::before, .details-table td {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
    }
  </style>
</head>
<body>
  <div class="content">
    <div class="title">Student Details</div>

    <!-- Header: Photo + Admission Code (No Border) -->
    <table class="header-table">
      <tr>
        <td class="photo-cell">
          ${student.student_photo_url ? `
          <div class="photo-section">
            <strong>Student Photo:</strong><br>
            <img src="${fixUrl(student.student_photo_url)}" class="student-photo" alt="Photo">
          </div>` : ''}
        </td>
        <td class="code-cell">
          <div class="admission-code">Admission Code: ${student.admission_code || "N/A"}</div>
        </td>
      </tr>
    </table>

    <!-- Main Details Table (With Borders) -->
    <table class="details-table">
      <tr><td><strong>Name</strong></td><td>${student.name}</td></tr>
      <tr><td><strong>Trade</strong></td><td>${student.trade}</td></tr>
      <tr><td><strong>Date of Birth</strong></td><td>${formattedDOB}</td></tr>
      <tr><td><strong>Address</strong></td><td>${student.address}</td></tr>
      <tr><td><strong>Father's Name</strong></td><td>${student.father_name}</td></tr>
      <tr><td><strong>Mother's Name</strong></td><td>${student.mother_name}</td></tr>
      <tr><td><strong>Gender</strong></td><td>${student.gender}</td></tr>
      <tr><td><strong>Religion</strong></td><td>${student.religion}</td></tr>
      <tr><td><strong>Community</strong></td><td>${student.community}</td></tr>
      <tr><td><strong>Sub Caste</strong></td><td>${student.sub_caste || "—"}</td></tr>
      <tr><td><strong>Annual Income</strong></td><td>₹${student.annual_income || "—"}</td></tr>
      <tr><td><strong>Qualification</strong></td><td>${student.qualification}</td></tr>
      <tr><td><strong>Aadhar No</strong></td><td>${student.aadhar_no}</td></tr>
      <tr><td><strong>Mobile No</strong></td><td>${student.mobile_no}</td></tr>
      <tr><td><strong>Orphan</strong></td><td>${student.orphan ? "Yes" : "No"}</td></tr>
      <tr><td><strong>First Graduate</strong></td><td>${student.first_graduation ? "Yes" : "No"}</td></tr>
      <tr><td><strong>Date of Admission</strong></td><td>${formattedAdmission}</td></tr>
    </table>

   <table class="header-table">
      <tr>
        <td class="photo-cell">
           <!-- Student Signature -->
    ${student.student_signature_url ? `
      <div class="photo-section">
        <strong>Student Signature:</strong><br>
        <img src="${fixUrl(student.student_signature_url)}" class="student-signature" alt="Signature">
      </div>` : ''}
        </td>
        <td class="code-cell">
          <div class="signature">Principal Signature</div>
        </td>
      </tr>
    </table>

  

    <!-- Scanned Documents Link -->
    ${student.scanned_documents_url ? `
      <div class="photo-section">
        <strong>Scanned Documents:</strong><br>
        <a href="${fixUrl(student.scanned_documents_url)}" target="_blank" rel="noopener">View Document</a>
      </div>` : ''}

    
  </div>

  <script>
    window.onload = () => setTimeout(() => window.print(), 300);
    window.onafterprint = () => window.close();
    const mq = window.matchMedia('print');
    mq.addEventListener('change', (m) => { if (!m.matches) setTimeout(() => window.close(), 100); });
  </script>
</body>
</html>
  `);

    popup.document.close();
    popup.focus();
  };

  const fixUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("https")) return url;
    const clean = url.startsWith("/") ? url : "/" + url;
    return `https://localhost${clean}`;
  };

  // Build unique lists for modal filters
  const uniqueCommunities = Array.from(new Set(students.map((s) => (s.community || "").trim()).filter(Boolean)));
  const uniqueQualifications = Array.from(
    new Set([
      ...tradeList.map((t) => (t.qualification || "").trim()).filter(Boolean),
      ...students.map((s) => (s.qualification || "").trim()).filter(Boolean),
    ])
  );
  const uniqueReligions = Array.from(new Set(students.map((s) => (s.religion || "").trim()).filter(Boolean)));
  const uniqueTrades = tradeList.map((t) => t.trade_name);

  // Normalize search
  const normalizedQuery = searchQuery.trim().toLowerCase();
  // ---- NEW: Unique admission years ----
  const uniqueYears = Array.from(
    new Set(
      students
        .map(s => s.date_of_admission ? new Date(s.date_of_admission).getFullYear() : null)
        .filter(y => y !== null)
    )
  ).sort((a, b) => b - a);   // newest first
  // Filtering logic: supports multi-select arrays
  const filteredStudents = students.filter((s) => {
    // existing checks …
    if (filterTrades.length > 0 && !filterTrades.includes(s.trade)) return false;
    if (filterQualifications.length > 0 && !filterQualifications.includes((s.qualification || "").trim())) return false;
    if (filterGenders.length > 0 && !filterGenders.includes((s.gender || "").trim())) return false;
    if (filterReligions.length > 0 && !filterReligions.includes((s.religion || "").trim())) return false;
    if (filterCommunities.length > 0 && !filterCommunities.includes((s.community || "").trim())) return false;

    // ---- FIXED: Orphan & First Graduate (store booleans) ----
    if (filterOrphan.length > 0 && !filterOrphan.includes(!!s.orphan)) return false;
    if (filterFirstGraduate.length > 0 && !filterFirstGraduate.includes(!!s.first_graduation)) return false;

    // ---- NEW: Batch year filter ----
    if (filterYears.length > 0) {
      const year = s.date_of_admission ? new Date(s.date_of_admission).getFullYear() : null;
      if (!year || !filterYears.includes(year)) return false;
    }

    // search …
    if (!normalizedQuery) return true;
    const fields = [/* …same as before… */];
    return fields.some((f) => f.toLowerCase().includes(normalizedQuery));
  });

  // helper toggles for modal temporary selections
  const toggleTemp = (value, arr, setArr) => {
    if (arr.includes(value)) setArr(arr.filter((a) => a !== value));
    else setArr([...arr, value]);
  };

  const openFilterModal = () => {
    setTempTrades([...filterTrades]);
    setTempQualifications([...filterQualifications]);
    setTempGenders([...filterGenders]);
    setTempReligions([...filterReligions]);
    setTempCommunities([...filterCommunities]);

    // Orphan / First Graduate – store booleans in applied filter
    setTempOrphan(filterOrphan.map(v => v ? 'Yes' : 'No'));
    setTempFirstGraduate(filterFirstGraduate.map(v => v ? 'Yes' : 'No'));

    setTempYears([...filterYears]);          // NEW
    setShowFilterModal(true);
  };

  const applyFiltersFromModal = () => {
    setFilterTrades([...tempTrades]);
    setFilterQualifications([...tempQualifications]);
    setFilterGenders([...tempGenders]);
    setFilterReligions([...tempReligions]);
    setFilterCommunities([...tempCommunities]);

    // Convert "Yes"/"No" → true/false
    setFilterOrphan(tempOrphan.map(v => v === 'Yes'));
    setFilterFirstGraduate(tempFirstGraduate.map(v => v === 'Yes'));

    setFilterYears([...tempYears]);          // NEW
    setShowFilterModal(false);
  };

  const clearModalSelections = () => {
    setTempTrades([]);
    setTempQualifications([]);
    setTempGenders([]);
    setTempReligions([]);
    setTempCommunities([]);
    setTempOrphan([]);
    setTempFirstGraduate([]);
    setTempYears([]);                        // NEW
  };

  // count active filters for badge
  const activeFilterCount = () =>
    filterTrades.length +
    filterQualifications.length +
    filterGenders.length +
    filterReligions.length +
    filterCommunities.length +
    filterOrphan.length +
    filterFirstGraduate.length +
    filterYears.length;          // NEW

  if (loading) {
    return (
      <div className="student-page">
        <div className="d-flex dashboard-container">
          <Sidebar />
          <div className="main-content flex-grow-1">
            <Header />
            <div className="container py-5 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
            <DashboardFooter />
          </div>
        </div>
      </div>
    );
  }

  // Define columns for the table based on view mode
  const tableColumns = showAllColumns ? [
    { header: 'Admission Code', accessor: 'admission_code' },
    { header: 'Name', accessor: 'name' },
    { header: 'Trade', accessor: 'trade' },
    { header: 'DOB', accessor: 'date_of_birth' },
    { header: 'Father\'s Name', accessor: 'father_name' },
    { header: 'Mother\'s Name', accessor: 'mother_name' },
    { header: 'Gender', accessor: 'gender' },
    { header: 'Religion', accessor: 'religion' },
    { header: 'Community', accessor: 'community' },
    { header: 'Qualification', accessor: 'qualification' },
    { header: 'Mobile', accessor: 'mobile_no' },
    { header: 'Aadhar', accessor: 'aadhar_no' },
    { header: 'Orphan', accessor: 'orphan', format: v => v ? 'Yes' : 'No' },
    { header: 'First Grad', accessor: 'first_graduation', format: v => v ? 'Yes' : 'No' },
    { header: 'Actions', accessor: 'actions' }
  ] : [
    { header: '#', accessor: 'index' },
    { header: 'Admission Code', accessor: 'admission_code' },
    { header: 'Name', accessor: 'name' },
    { header: 'Trade', accessor: 'trade' },
    { header: 'Gender', accessor: 'gender' },
    { header: 'Mobile', accessor: 'mobile_no' },
    { header: 'Qualification', accessor: 'qualification' },
    { header: 'Actions', accessor: 'actions' }
  ];

  return (
    <div className="student-page">
      <div className="d-flex dashboard-container">
        <Sidebar />
        <div className="main-content flex-grow-1">
          <Header />
          <div className="container py-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="fw-bold">Student Database</h3>
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-2"
                  onClick={async () => {
                    await fetchTrades();
                    await fetchStudents();
                  }}
                >
                  <FaSync className="me-1" /> Refresh
                </button>
<button className="btn btn-success me-2" onClick={exportToExcel}>
  <FaDownload className="me-2" />
  Export Excel
  {filteredStudents.length !== students.length && (
    <span className="badge bg-light text-dark ms-1">
      {filteredStudents.length}
    </span>
  )}
</button>
                <button
                  className="btn btn-outline-primary me-2 d-flex align-items-center"
                  onClick={openFilterModal}
                  title="Open filters"
                >
                  <FaFilter className="me-2" /> Filters
                  {activeFilterCount() > 0 && (
                    <span className="badge bg-danger ms-2">{activeFilterCount()}</span>
                  )}
                </button>
                <button
                  className="btn btn-outline-secondary me-2 d-flex align-items-center"
                  onClick={() => setShowAllColumns(!showAllColumns)}
                  title={showAllColumns ? "Show basic table" : "Show all columns"}
                >
                  <FaTable className="me-2" />
                  {showAllColumns ? "Basic View" : "Full View"}
                </button>
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={openAddForm}
                >
                  <FaPlus className="me-2" /> Add Student
                </button>
              </div>
            </div>
            {/* Search bar */}
            <div className="card mb-4 p-3">
              <div className="row g-2 align-items-center">
                <div className="col-md-8">
                  <div className="input-group">
                    <span className="input-group-text"><FaSearch /></span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search name / father / mother / aadhar / mobile / admission code / trade / qualification..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                      <button className="btn btn-outline-secondary" onClick={() => setSearchQuery("")}>
                        <FaTimes />
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-md-4 text-end">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      // clear applied filters
                      setFilterTrades([]);
                      setFilterQualifications([]);
                      setFilterGenders([]);
                      setFilterReligions([]);
                      setFilterCommunities([]);
                      setFilterOrphan([]);
                      setFilterFirstGraduate([]);
                      setSearchQuery("");
                      // inside the “Clear All Filters” onClick
                      setFilterYears([]);
                    }}
                  >
                    Clear All Filters
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}
            {showForm && (
              <form className="card shadow-lg p-4 mb-5" onSubmit={handleSubmit}>
                <h5 className="fw-bold mb-3 text-primary">
                  {editStudent ? "Edit Student" : "Add New Student"}
                </h5>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">Name of Trainee *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Trade *</label>
                    <select
                      className="form-select"
                      name="trade"
                      value={formData.trade}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      {tradeList.map((t) => (
                        <option key={t.trade_id} value={t.trade_name}>
                          {t.trade_name}
                        </option>
                      ))}
                      {tradeList.length === 0 && (
                        <>
                          <option value="Welder">Welder</option>
                          <option value="Plumber">Plumber</option>
                          <option value="Electrician">Electrician</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Date of Birth</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Father's Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="father_name"
                      value={formData.father_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Mother's Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mother_name"
                      value={formData.mother_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Gender</label>
                    <select
                      className="form-select"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Religion</label>
                    <select
                      className="form-select"
                      name="religion"
                      value={formData.religion}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Christian">Christian</option>
                      <option value="Hindu">Hindu</option>
                      <option value="Muslim">Muslim</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Community</label>
                    <input
                      type="text"
                      className="form-control"
                      name="community"
                      value={formData.community}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Sub Caste</label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_caste"
                      value={formData.sub_caste}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Annual Income</label>
                    <input
                      type="number"
                      className="form-control"
                      name="annual_income"
                      value={formData.annual_income}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Qualification</label>
                    <select
                      className="form-select"
                      name="qualification"
                      value={formData.qualification}
                      onChange={handleChange}
                    >
                      <option value="">Select / Type</option>
                      {uniqueQualifications.map((q, idx) => (
                        <option key={idx} value={q}>{q}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Aadhar No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="aadhar_no"
                      value={formData.aadhar_no}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Mobile No *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Orphan</label>
                    <select
                      className="form-select"
                      name="orphan"
                      value={formData.orphan}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">First Graduate</label>
                    <select
                      className="form-select"
                      name="first_graduation"
                      value={formData.first_graduation}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Date of Admission</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date_of_admission"
                      value={formData.date_of_admission}
                      onChange={handleChange}
                    />
                  </div>
                  {/* File uploads */}
                  <div className="col-md-4">
                    <label className="form-label">Student Photo (JPG/PNG)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="student_photo"
                      onChange={handleChange}
                      accept="image/*"
                    />
                    {editStudent && editStudent.student_photo_url && (
                      <div className="mt-1">
                        <small>Current:</small>
                        <img
                          src={fixUrl(editStudent.student_photo_url)}
                          alt="Current Photo"
                          className="img-thumbnail"
                          style={{ height: "60px", width: "60px", objectFit: "cover" }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Student Signature (JPG/PNG)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="student_signature"
                      onChange={handleChange}
                      accept="image/*"
                    />
                    {editStudent && editStudent.student_signature_url && (
                      <div className="mt-1">
                        <small>Current:</small>
                        <img
                          src={fixUrl(editStudent.student_signature_url)}
                          alt="Current Signature"
                          className="img-thumbnail"
                          style={{ height: "40px", width: "100px", objectFit: "contain" }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Scanned Documents (PDF/JPG/PNG)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="scanned_documents"
                      onChange={handleChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    {editStudent && editStudent.scanned_documents_url && (
                      <div className="mt-1">
                        <small>Current:</small>
                        <a
                          href={fixUrl(editStudent.scanned_documents_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          View Document
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-success px-4">
                    {editStudent ? "Update Student" : "Save Student"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
            {/* Table */}
            {/* Table */}
            <div className={showAllColumns ? "table-responsive-horizontal" : "table-responsive"}>
              <table className="table table-striped table-bordered align-middle">
                <thead className="table-dark text-center">
                  <tr>
                    {tableColumns.map((col, idx) => (
                      <th key={idx}>{col.header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.map((s, i) => (
                    <tr key={s.student_id}>
                      {tableColumns.map((col, idx) => {
                        if (col.accessor === 'index') {
                          return <td key={idx} className="text-center">{i + 1}</td>;
                        } else if (col.accessor === 'actions') {
                          return (
                            <td key={idx} className="text-center">
                              <button className="btn btn-sm btn-info me-1" onClick={() => handleView(s)}>
                                <FaEye />
                              </button>
                              <button className="btn btn-sm btn-warning me-1" onClick={() => handleEdit(s)}>
                                <FaEdit />
                              </button>
                              <button className="btn btn-sm btn-danger me-1" onClick={() => handleDelete(s.student_id)}>
                                <FaTrash />
                              </button>
                              <button className="btn btn-sm btn-primary ms-1" onClick={() => handlePrintForStudent(s)} title="Print Student Details">
                                <FaDownload />
                              </button>
                            </td>
                          );
                        } else if (col.accessor === 'admission_code') {
                          return <td key={idx}>{s.admission_code || "—"}</td>;
                        } else if (col.accessor === 'orphan' || col.accessor === 'first_graduation') {
                          return <td key={idx}>{s[col.accessor] ? 'Yes' : 'No'}</td>;
                        } else if (col.format) {
                          return <td key={idx}>{col.format(s[col.accessor])}</td>;
                        } else {
                          return <td key={idx}>{s[col.accessor] || "—"}</td>;
                        }
                      })}
                    </tr>
                  ))}
                  {filteredStudents.length === 0 && (
                    <tr>
                      <td colSpan={tableColumns.length} className="text-center text-muted">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* View Modal */}
            {showViewModal && selectedStudent && (
              <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setShowViewModal(false)}
              >
                <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Student Details</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowViewModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <p><strong>Name:</strong> {selectedStudent.name}</p>
                          <p><strong>Trade:</strong> {selectedStudent.trade}</p>
                          <p><strong>DOB:</strong> {selectedStudent.date_of_birth || "—"}</p>
                          <p><strong>Address:</strong> {selectedStudent.address}</p>
                          <p><strong>Father:</strong> {selectedStudent.father_name}</p>
                          <p><strong>Mother:</strong> {selectedStudent.mother_name}</p>
                          <p><strong>Gender:</strong> {selectedStudent.gender}</p>
                          <p><strong>Religion:</strong> {selectedStudent.religion}</p>
                          <p><strong>Community:</strong> {selectedStudent.community}</p>
                          <p><strong>Sub Caste:</strong> {selectedStudent.sub_caste}</p>
                        </div>
                        <div className="col-md-6">
                          <p><strong>Annual Income:</strong> ₹{selectedStudent.annual_income || "—"}</p>
                          <p><strong>Qualification:</strong> {selectedStudent.qualification}</p>
                          <p><strong>Aadhar:</strong> {selectedStudent.aadhar_no}</p>
                          <p><strong>Mobile:</strong> {selectedStudent.mobile_no}</p>
                          <p><strong>Orphan:</strong> {selectedStudent.orphan ? 'Yes' : 'No'}</p>
                          <p><strong>First Graduate:</strong> {selectedStudent.first_graduation ? 'Yes' : 'No'}</p>
                          <p><strong>Admission Date:</strong> {selectedStudent.date_of_admission || "—"}</p>
                          <p><strong>Admission Code:</strong> {selectedStudent.admission_code}</p>
                          {selectedStudent.student_photo_url && (
                            <div className="mt-3">
                              <strong><FaImage className="me-2" /> Photo:</strong>
                              <div className="mt-2">
                                <img
                                  src={fixUrl(selectedStudent.student_photo_url)}
                                  alt="Student Photo"
                                  className="img-fluid border rounded"
                                  style={{ maxHeight: "120px", objectFit: "cover" }}
                                />
                              </div>
                            </div>
                          )}
                          {selectedStudent.student_signature_url && (
                            <div className="mt-3">
                              <strong><FaSignature className="me-2" /> Signature:</strong>
                              <div className="mt-2">
                                <img
                                  src={fixUrl(selectedStudent.student_signature_url)}
                                  alt="Student Signature"
                                  className="img-fluid border rounded"
                                  style={{ maxHeight: "60px", objectFit: "contain" }}
                                />
                              </div>
                            </div>
                          )}
                          {selectedStudent.scanned_documents_url && (
                            <div className="mt-3">
                              <strong><FaFilePdf className="me-2" /> Documents:</strong>
                              <div className="mt-2">
                                <a
                                  href={fixUrl(selectedStudent.scanned_documents_url)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  <FaFilePdf className="me-1" />
                                  View Document
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setShowViewModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Filter Modal */}
            {showFilterModal && (
              <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setShowFilterModal(false)}
              >
                <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Filters</h5>
                      <button type="button" className="btn-close" onClick={() => setShowFilterModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        {/* Trades */}
                        <div className="col-md-6 mb-3">
                          <h6>Trades</h6>
                          <div className="filter-list" style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #eee", padding: 8, borderRadius: 4 }}>
                            {uniqueTrades.length === 0 ? (
                              <div className="text-muted">No trades available</div>
                            ) : (
                              uniqueTrades.map((t) => (
                                <div key={t} className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`trade_${t}`}
                                    checked={tempTrades.includes(t)}
                                    onChange={() => toggleTemp(t, tempTrades, setTempTrades)}
                                  />
                                  <label className="form-check-label" htmlFor={`trade_${t}`}>{t}</label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                        {/* Qualifications */}
                        <div className="col-md-6 mb-3">
                          <h6>Qualifications</h6>
                          <div className="filter-list" style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #eee", padding: 8, borderRadius: 4 }}>
                            {uniqueQualifications.length === 0 ? (
                              <div className="text-muted">No qualifications available</div>
                            ) : (
                              uniqueQualifications.map((q) => (
                                <div key={q} className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`qual_${q}`}
                                    checked={tempQualifications.includes(q)}
                                    onChange={() => toggleTemp(q, tempQualifications, setTempQualifications)}
                                  />
                                  <label className="form-check-label" htmlFor={`qual_${q}`}>{q}</label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                        {/* Gender */}
                        <div className="col-md-4 mb-3">
                          <h6>Gender</h6>
                          <div className="filter-list">
                            {["Male", "Female", "Other"].map((g) => (
                              <div key={g} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`gender_${g}`}
                                  checked={tempGenders.includes(g)}
                                  onChange={() => toggleTemp(g, tempGenders, setTempGenders)}
                                />
                                <label className="form-check-label" htmlFor={`gender_${g}`}>{g}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* Religion */}
                        <div className="col-md-4 mb-3">
                          <h6>Religion</h6>
                          <div className="filter-list" style={{ maxHeight: 120, overflowY: "auto" }}>
                            {uniqueReligions.length === 0 ? <div className="text-muted">No items</div> : uniqueReligions.map((r) => (
                              <div key={r} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`rel_${r}`}
                                  checked={tempReligions.includes(r)}
                                  onChange={() => toggleTemp(r, tempReligions, setTempReligions)}
                                />
                                <label className="form-check-label" htmlFor={`rel_${r}`}>{r}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* Community */}
                        <div className="col-md-4 mb-3">
                          <h6>Community</h6>
                          <div className="filter-list" style={{ maxHeight: 120, overflowY: "auto" }}>
                            {uniqueCommunities.length === 0 ? <div className="text-muted">No items</div> : uniqueCommunities.map((c) => (
                              <div key={c} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`com_${c}`}
                                  checked={tempCommunities.includes(c)}
                                  onChange={() => toggleTemp(c, tempCommunities, setTempCommunities)}
                                />
                                <label className="form-check-label" htmlFor={`com_${c}`}>{c}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* Orphan */}
                        <div className="col-md-6 mb-3">
                          <h6>Orphan</h6>
                          <div className="filter-list">
                            {["Yes", "No"].map((o) => (
                              <div key={o} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`orp_${o}`}
                                  checked={tempOrphan.includes(o)}
                                  onChange={() => toggleTemp(o, tempOrphan, setTempOrphan)}
                                />
                                <label className="form-check-label" htmlFor={`orp_${o}`}>{o}</label>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* First Graduate */}
                        <div className="col-md-6 mb-3">
                          <h6>First Graduate</h6>
                          <div className="filter-list">
                            {["Yes", "No"].map((f) => (
                              <div key={f} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`fg_${f}`}
                                  checked={tempFirstGraduate.includes(f)}
                                  onChange={() => toggleTemp(f, tempFirstGraduate, setTempFirstGraduate)}
                                />
                                <label className="form-check-label" htmlFor={`fg_${f}`}>{f}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* ---- NEW: Batch (Admission Year) ---- */}
                        <div className="col-md-6 mb-3">
                          <h6>Batch (Admission Year)</h6>
                          <div className="filter-list" style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #eee", padding: 8, borderRadius: 4 }}>
                            {uniqueYears.length === 0 ? (
                              <div className="text-muted">No years available</div>
                            ) : (
                              uniqueYears.map((y) => (
                                <div key={y} className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`year_${y}`}
                                    checked={tempYears.includes(y)}
                                    onChange={() => toggleTemp(y, tempYears, setTempYears)}
                                  />
                                  <label className="form-check-label" htmlFor={`year_${y}`}>{y}</label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="w-100 d-flex justify-content-between">
                        <div>
                          <button
                            className="btn btn-outline-secondary me-2"
                            onClick={() => clearModalSelections()}
                            type="button"
                          >
                            Clear Selections
                          </button>
                          <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                              // clear applied filters too
                              clearModalSelections();
                              setFilterTrades([]);
                              setFilterQualifications([]);
                              setFilterGenders([]);
                              setFilterReligions([]);
                              setFilterCommunities([]);
                              setFilterOrphan([]);
                              setFilterFirstGraduate([]);
                              setShowFilterModal(false);
                            }}
                            type="button"
                          >
                            Clear All Filters
                          </button>
                        </div>
                        <div>
                          <button
                            className="btn btn-secondary me-2"
                            onClick={() => setShowFilterModal(false)}
                            type="button"
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => applyFiltersFromModal()}
                            type="button"
                          >
                            Apply Filters
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;